export default "__VITE_ASSET__Ds33KvrX__"